











































import { snakeCase } from 'lodash'
import { Component, Prop } from 'vue-property-decorator'

import { SampleNodeMixin } from '../../../../index'
import { DelayNode } from '../../logic/DelayNode'
import {
  ProxyDelayDateType,
  ProxyDelayPropertyType,
  ProxyDelayIntervalType,
} from '../../logic/Proxy/ProxyDelayTypes'
import SampleDelayDateType from './SampleDelayTypes/SampleDelayDateType.vue'
import SampleDelayIntervalType from './SampleDelayTypes/SampleDelayIntervalType.vue'
import SampleDelayPropertyType from './SampleDelayTypes/SampleDelayPropertyType.vue'

@Component({
  data() {
    return {
      snakeCase,
      ProxyDelayDateType,
      ProxyDelayPropertyType,
      ProxyDelayIntervalType,
    }
  },
  components: {
    SampleDelayDateType,
    SampleDelayIntervalType,
    SampleDelayPropertyType,
  }
})
export default class DelaySampleNode extends SampleNodeMixin{
  @Prop() node!: DelayNode
}
